/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Visitor_Allowlist_HintInputs */



/**
* | output |
* | --- |
* | "One entry per line: an address (ada@acme.de) or a whole domain (@acme.de). Leave empty to let anyone sign in. Visitors are never told whether they are on thi..." |
*
* @param {Artifact_Visitor_Allowlist_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_visitor_allowlist_hint = /** @type {((inputs?: Artifact_Visitor_Allowlist_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Visitor_Allowlist_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Eintrag pro Zeile: eine Adresse (ada@acme.de) oder eine ganze Domain (@acme.de). Leer lassen, damit sich alle anmelden können. Besuchern wird nie mitgeteilt, ob sie auf dieser Liste stehen.")
	return /** @type {LocalizedString} */ ("One entry per line: an address (ada@acme.de) or a whole domain (@acme.de). Leave empty to let anyone sign in. Visitors are never told whether they are on this list.")
});